import LanguageSVG from '../../assets/svgs/Language.svg';

import classes from './SiderElement.module.scss';

export default function Language({ text, i18n, language }) {
  const changeLanguageHandler = () => {
    i18n.changeLanguage(language === 'fa' ? 'en' : 'fa');
  };

  return (
    <div
      className={`${classes.link} ${classes[language]}`}
      onClick={changeLanguageHandler}
    >
      <span>
        <img src={LanguageSVG} alt={text} className={classes.icon} />
      </span>
      <span className={classes['link-text']}>{text}</span>
    </div>
  );
}
